import { useEffect, useState, lazy, Suspense } from 'react';
import 'leaflet/dist/leaflet.css';

// Componente Map com lazy loading
const MapComponent = lazy(() => import('./map-component'));

interface MapWrapperProps {
  center?: [number, number];
  zoom?: number;
  markers?: Array<{
    position: [number, number];
    title?: string;
    description?: string;
  }>;
  onMarkerClick?: (position: [number, number]) => void;
  onMapClick?: (position: [number, number]) => void;
  editable?: boolean;
  interactive?: boolean;
  height?: string;
}

export default function MapWrapper(props: MapWrapperProps) {
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    setMounted(true);
  }, []);

  if (!mounted) {
    return (
      <div className="h-[400px] bg-gray-100 dark:bg-gray-800 rounded-xl flex items-center justify-center">
        <p className="text-gray-500 dark:text-gray-400">Carregando mapa...</p>
      </div>
    );
  }

  return (
    <Suspense
      fallback={
        <div className="h-[400px] bg-gray-100 dark:bg-gray-800 rounded-xl flex items-center justify-center">
          <p className="text-gray-500 dark:text-gray-400">Carregando mapa...</p>
        </div>
      }
    >
      <MapComponent {...props} />
    </Suspense>
  );
}

